import { ClickAwareContainerProps } from 'layout/click-aware-container/click-aware-container.props';

export const ClickAwareContainerPresets: ClickAwareContainerProps = {
  visible: true,
};
